import type { RecentActivityItem } from './types.tsx';

/**
 * Extracts the Jira workItem key from an activity node if the product is Jira.
 * @param activity RecentActivityItem
 * @returns The workItem key string if present and product is Jira, otherwise undefined.
 */
export const getJiraWorkItemKeyFromActivity = (
	activity: RecentActivityItem,
): string | undefined => {
	if (
		activity?.data.node.object.type === 'issue' &&
		activity?.data.node.object.product === 'jira' &&
		activity?.data.node.object.data &&
		'key' in activity?.data.node.object.data
	) {
		return activity?.data.node.object.data.key;
	}
	return undefined;
};
